import { createFileRoute, Outlet } from "@tanstack/react-router";
import { ChannelProvider } from "ably/react";
import { useEffect } from "react";
import { servicesOrchestratorValues } from "@/config/services";
import { PeerConnectionError } from "@/hooks/usePeerConnectionErrors";
import { AblyProvider, configureAbly } from "@/lib/ably";
import { PresenceProvider, visionAblyChannelName } from "@/lib/ably/vision";
import logger from "@/lib/logging/logger";
import { useStore } from "@/store";

configureAbly({ logger });

export const Route = createFileRoute("/$locale/$partner/_app/_card/_paired")({
	component: PairedDeviceLayout,
});

function PairedDeviceLayout() {
	const sessionId = useStore((state) => state.sessionId);
	const setError = useStore((state) => state.setError);
	const channelName = visionAblyChannelName(sessionId);

	useEffect(() => {
		return () => {
			if (useStore.getState().error instanceof PeerConnectionError) {
				setError(null);
			}
		};
	}, [setError]);

	return (
		<AblyProvider
			apiKey={servicesOrchestratorValues.credentials.ablyKey}
			clientId="scanner-device"
			logger={logger}
		>
			<ChannelProvider channelName={channelName}>
				<PresenceProvider channelName={channelName} />
				<Outlet />
			</ChannelProvider>
		</AblyProvider>
	);
}
